module.exports = __webpack_public_path__ + "img/model_zh_66.941027d0.png";